export default "__VITE_ASSET__BsTv$VAI__"